import * as React from 'react'
import {ComponentExt} from '@utils/reactExt'
import * as styles from './style/index.scss'
import BindBg from '@assets/img/global/banner_tp1.png'
import SimCardImg from '@assets/img/global/card.png'
import {ImagePicker} from 'antd-mobile'
import {FormattedMessage} from 'react-intl'
import intl from '@utils/intl';
import {homeStoreG} from '@src/containers/viewsG/home/actor/store'
import compress from '@utils/compress'
import { userStore } from '@src/store/userStore'
import { TRYBUY_EVENT_TRACING_PAGE, TRYBUY_EVENT_TRACING_CLICK } from '@src/constants'
class BinsSim extends ComponentExt<any> {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const uploadImgText = intl.formatMessage({id: 'bindSim.btn.text'})
        document.getElementsByClassName('am-image-picker-upload-btn')[0].setAttribute('data-content', uploadImgText)
        userStore.sendEventTracing({
            pageCode: TRYBUY_EVENT_TRACING_PAGE.TRYBUY_PAGE_BINDSIM,
            buttonCode: '',
            buttonInfo: ''
        })
    }

    getFileUrl = (file) => {
        let url;
        const agent = navigator.userAgent;
        if (agent.indexOf('MSIE') >= 1) {
            url = file.value;
        } else if (agent.indexOf('Firefox') > 0 || agent.indexOf('Chrome') > 0) {
            url = window.URL.createObjectURL(file);
        }
        return url;
    }
    compressCallBack = async (file, fileObj, result) => {
        file.compressing = false; // 压缩完成
        fileObj.compressBase64 = result.compressBase64;
        fileObj.compressFile = result.compressFile;
        console.log('全部压缩完成', fileObj);
        const formData = new FormData()
        formData.append('file', fileObj.compressFile);
        try {
            await this.api.uploadAndBind(formData)
            this.$toast.info(intl.formatMessage({id: 'iCode.i0055'}), 1.5, async () => {
                await homeStoreG.getUserInfo()
                this.replacePath('/global/home')
            })
        } catch (e) {} finally {
            this.hideLoading()
        }
    }
    // 上传图片并绑定sim卡
    changeImage = async e => {
        this.showLoading()
        const file = e[0].file
        file.url = this.getFileUrl(file);
        file.compressing = true; // 压缩状态，开始压缩
        const fileObj = {originFile: file, compressBase64: null, compressFile: null};
        // 压缩图片的方法, maxSize单位为kb
        compress(file, 200).then((res) => {
            this.compressCallBack(file, fileObj, res);
        }, (err) => {
            // 压缩失败，则返回原图片的信息
            this.compressCallBack(file, fileObj, err);
        });
        userStore.sendEventTracing({
            pageCode: '',
            buttonCode: TRYBUY_EVENT_TRACING_CLICK.TRYBUY_BIND_SIM,
            buttonInfo: ''
        })
    }

    render() {
        return (
            <div className={styles.bindSimWrap}>
                <img src={BindBg} className={styles.bg}/>
                <div className={styles.topWrap}>
                    <h2><FormattedMessage id="bindSim.hello"/>,</h2>
                    <p><FormattedMessage id="bindSim.activate.title"/></p>
                </div>
                <section className={styles.bindWrap}>
                    <p>
                        <span className={styles.num}>1</span>
                        <span className={styles.tipText}><FormattedMessage id="bindSim.tip.text1"/></span>
                    </p>
                    <img src={SimCardImg} className={styles.simCardImg}/>
                    <p>
                        <span className={styles.num}>2</span>
                        <span className={styles.tipText}><FormattedMessage id="bindSim.tip.text2"/></span>
                    </p>
                    <ImagePicker length={1} onChange={this.changeImage}/>
                </section>
            </div>
        )
    }
}

export default BinsSim
